import { useEffect, useRef } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { logError } from "@/lib/log";

const PING_MS = 60000; // send at most one location ping per minute

/**
 * Invisible component: while a logged-in DRIVER has the Driver day page open,
 * it watches their GPS and pings the backend so the admin Live map can track them.
 */
export default function DriverLocationBeacon() {
  const { user } = useAuth();
  const lastSent = useRef(0);

  useEffect(() => {
    if (user?.role !== "driver" || !navigator.geolocation) return undefined;
    const send = (pos) => {
      const now = Date.now();
      if (now - lastSent.current < PING_MS) return;
      lastSent.current = now;
      api.post("/driver/location", {
        latitude: pos.coords.latitude,
        longitude: pos.coords.longitude,
        accuracy: pos.coords.accuracy,
      }).catch((e) => logError("Driver location ping failed:", e));
    };
    const watchId = navigator.geolocation.watchPosition(send, () => {}, {
      enableHighAccuracy: false,
      maximumAge: 30000,
      timeout: 15000,
    });
    return () => navigator.geolocation.clearWatch(watchId);
  }, [user?.role]);

  return null;
}
